<template>
  <v-container fluid>
    <v-tabs fixed-tabs background-color="primary" dark>
      <v-tab>
        {{ $t("formula.toolbarTitle") }}
      </v-tab>
      <v-tab>
        {{ $t("formula.template.tableHeader") }}
      </v-tab>
      <v-tab>
        {{ $t("formula.constant.tableHeader") }}
      </v-tab>

      <v-tab-item> <formula-list /> </v-tab-item>
      <v-tab-item> <formula-template-list /> </v-tab-item>
      <v-tab-item> <constant-list /> </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import FormulaList from "./FormulaList.vue";
import FormulaTemplateList from "./template/FormulaTemplateList.vue";
import ConstantList from "./constant/ConstantList.vue";

export default {
  name: "Formula",
  components: {
    FormulaList,
    FormulaTemplateList,
    ConstantList,
  },
};
</script>
